
import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../../Types/ObjektVy';
import { useQuery } from '@apollo/client';
import AttestantQuery from '../Queries/AttestanterQuery/AttestanterQuery.gql';
import {
  FakturansAttestanter as IData,
  FakturansAttestanterVariables as IVariables,
  FakturansAttestanter_node_TEDLRLeverantorfaktura__Associations_Fakturadel,
} from '../Queries/AttestanterQuery/_QueryTypes/FakturansAttestanter';
import { isEmpty } from 'ramda';
import EDView from '../../../../../../BaseComponents/View/EDView';
import { FakturaDelensAttestanter } from '../../FakturaDel/Components/Attestanter';
import mergeSort from '../../../../../../Utils/mergeSort';
import { selectedId } from '../../../../../../Components/MasterDetail/MasterDetailUtils';

interface IFakturansAttestanterProps {
  allExpanded?: boolean;
}
export const FakturansAttestanter = (
  props: IBusinessCollectionProps & IFakturansAttestanterProps
) => {
  const queryResult = useQuery<IData, IVariables>(AttestantQuery, {
    variables: { id: selectedId(props.id) ?? '' },
    skip: props.id === null,
  });

  const fakturadelarLista: FakturansAttestanter_node_TEDLRLeverantorfaktura__Associations_Fakturadel[] =
    (queryResult.data?.node?.__typename === 'TEDLRLeverantorfaktura'
      ? queryResult.data.node._Associations?.Fakturadel
        ? mergeSort(
            queryResult.data.node._Associations.Fakturadel,
            (a, b) => Number(a.ORDNINGS_NR) - Number(b.ORDNINGS_NR)
          )
        : null
      : []) ?? [];

  if (!queryResult.loading && isEmpty(fakturadelarLista)) {
    return queryResult.error ? (
      <>Fel vid hämtning av fakturadelar</>
    ) : (
      <>Fakturadelar saknas</>
    );
  }

  // const kontrollAttestantLista: FakturaDelAttestanter_node_TEDLRFakturaDel__Associations_Fakturaattest[];
  return (
    <EDView flexContainer>
      {fakturadelarLista.map(fakturadel => (
        <FakturaDelensAttestanter
          key={fakturadel.id}
          fakturadel={fakturadel}
          allExpanded={props.allExpanded}
        />
      ))}
    </EDView>
  );
};

export const AttestanterComp: IObjektVyComp = {
  caption: '',
  comp: FakturansAttestanter,
};

export const Attestanter: IObjektVy = {
  type: 'ObjektVy',
  id: 'Attestanter',
  info: {},
  def: () => AttestanterComp,
};
